import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TProductCart, TProductCartResponse, adaptProductCartFromResponse } from '../../types';
import { BACKEND_ACCOUNT_PRODUCT_CART } from '../../backend-paths';


export const accountProductCartReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ACCOUNT_PRODUCT_CART}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PRODUCT_CART}/${payload}`;

		return HttpService.get<TProductCartResponse>(path).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProductCartReadSlice = createSlice({
	name: 'accountProductCartReadSlice',
	initialState,
	reducers: {
		setAccountProductCartRead(state, action: PayloadAction<TProductCart>) {
			state.item = action.payload;
		},

		clearAccountProductCartRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductCartReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProductCartReadGetApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProductCartReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProductCartReadSelector = () => useAppSelector(state => state[accountProductCartReadSlice.name]);

export const { clearAccountProductCartRead, setAccountProductCartRead } = accountProductCartReadSlice.actions;
